import { z, ZodDate, ZodType } from 'zod';

export type ResponseBase =
  | Record<string, unknown>
  | unknown[]
  | number
  | string
  | null
  | boolean
  | undefined
  | void;

export const formErrorsSchema = z.object({
  code: z.number(),
  message: z.string(),
  errors: z.record(z.string(), z.array(z.string())),
});

export const listResponseSchema = <TItemSchema extends z.ZodType>(itemSchema: TItemSchema) =>
  z.object({
    result: z.array(itemSchema),
    pageSize: z.number(),
    pageCount: z.number(),
    rowCount: z.number(),
  });

export const apiDate = <TType extends ZodType = ZodDate>(chainSchema?: (date: ZodDate) => TType) =>
  z.preprocess(
    (value) => (value === null ? null : new Date(value as string)),
    chainSchema?.(z.date()) ?? z.date()
  );
